class PurchaseInvoiceListViewController extends InvoiceListViewController
{
    static newInstance():PurchaseInvoiceListViewController {
        let vc = new PurchaseInvoiceListViewController("invoice-list-view");
        vc.initWithResource("layout/invoices/InvoiceListView.html");        
        return vc;
    }

    get entityName():string { return "PurchaseInvoice"; }
    get customPredicateFormatOnSearch():string { return this.searchString != null ? "externalReference CONTAINS '" + this.searchString + "'" : null; }

    viewDidLoad() {
        super.viewDidLoad();          
        this.titleLabel.text = MIOLocalizeString("PURCHASE_INVOICES", "PURCHASE INVOICES");
    }

    viewWillAppear(animate){
        super.viewWillAppear(animate);

        MIONotificationCenter.defaultCenter().addObserver(this, "ReloadAndShowPurchaseInvoiceNotification", function(this:PurchaseInvoiceListViewController, note:MIONotification){
            DBHelper.queryObjectWithCompletion("PurchaseInvoice", null, MIOPredicate.predicateWithFormat("identifier = '" + note.object + "'"), [], this, function(this:PurchaseInvoiceListViewController, object:PurchaseInvoice){
                if (object == null) return;

                this.selectedItem = object;
                this.showSelectedItem();
                let ip = this.fetchedResultsController.indexPathForObject(object);
                this.tableView.selectRowAtIndexPath(ip, true);
            });
        });
    }

    protected newCellAtIndexPath(tableView:UITableView, item:Invoice, indexPath:MIOIndexPath) : UITableViewCell {
        if (item.ocrStatus == DBDocumentOCRStatus.scanning) {
            let cell = tableView.dequeueReusableCellWithIdentifier("ProcessingInvoiceCell") as ProcessingInvoiceCell;
            cell.item = item;
            return cell;
        }
        return super.newCellAtIndexPath(tableView,item,indexPath);
    }


    protected showSelectedItem() {
        let inv = this.selectedItem as PurchaseInvoice;
        if (inv != null && (inv.ocrStatus == DBDocumentOCRStatus.scanning || inv.ocrStatus == DBDocumentOCRStatus.failed)) {
            let vc = PurchaseInvoiceProcessingViewController.newInstance();
            vc.invoice = inv;
            this.splitViewController.showDetailViewController(vc);
        } else {
            let vc = PurchaseInvoiceDetailViewController.newInstance();
            vc.item = this.selectedItem;
            this.splitViewController.showDetailViewController(vc);
        }
    }

    protected addInvoice(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("OPTIONS", "OPTIONS"), MIOLocalizeString("SELECT_AN_OPTION", "SELECT AN OPTION"), MUIAlertViewStyle.Default);

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("QUICK_INVOICE", "QUICK INVOICE"), MUIAlertActionStyle.Default, this, function(this:PurchaseInvoiceListViewController){
            this.showLegalEntitySelectionViewController( null, LegalEntityDefaultSelectionType.supplier, {"type":"quick"} );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("MANUAL_INVOICE", "MANUAL INVOICE"), MUIAlertActionStyle.Default, this, function(this:PurchaseInvoiceListViewController){
            this.showLegalEntitySelectionViewController( null, LegalEntityDefaultSelectionType.supplier, null );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("INVOICE_FROM_NOTES", "INVOICE FROM NOTES"), MUIAlertActionStyle.Default, this, function(this:PurchaseInvoiceListViewController){
            let vc = SelectDocumentViewController.newInstance();
            vc.documentType = SelectDocumentViewControllerType.supplierNote;
            this.presentViewController(vc, true);
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("INVOICE_FROM_FILE", "INVOICE FROM FILE"), MUIAlertActionStyle.Default, this, function(this:PurchaseInvoiceListViewController){
            this.showLegalEntitySelectionViewController( null, LegalEntityDefaultSelectionType.supplier, {"type":"file"} );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        this.presentViewController(avc, true);
    }

    protected createNewInvoice( entity:LegalEntity, numberSequence: NumberSerialSequence, userInfo:any ) {
        if (userInfo != null && userInfo["type"] == "quick") {
            this.showQuickPurchaseInvoice(entity);
        } else if (userInfo != null && userInfo["type"] == "file") {
            this.pickInvoiceFile(entity);
        } else {
            this.createNextNumber(entity, userInfo);
        }
    }
    
    protected createNextNumber( entity:LegalEntity, info: any ){
        
        DBHelper.nextDocumentNumber("PurchaseInvoice", -1, (documentID:string, documentPrefix:string, documentNumber:number, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }

            this.createPurchaseInvoice(entity, documentID, info);
        });
    }

    protected createPurchaseInvoice(entity:LegalEntity, documentNumber:string, info:any){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let inv = MIOEntityDescription.insertNewObjectForEntityForName( this.entityName, ad.managedObjectContext ) as Invoice;

        inv.identifier = MIOUUID.UUID().UUIDString;
        inv.documentNumber = documentNumber;
        inv.legalEntity = entity;
        //inv.legalTaxFactor = entity.legalTax != null ? entity.legalTax.value : 0;
        inv.date = new Date();        
        if (inv instanceof PurchaseInvoice) inv.accountingDate = new Date();
        this.selectedItem = inv;        

        this.createInvoiceWithInfo(inv, info);

        DBHelper.saveMainContext();

        this.showSelectedItem();
    }

    private showQuickPurchaseInvoice(legalEntity:LegalEntity)
    {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("QUICK_INVOICE", "QUICK INVOICE"), MIOLocalizeString("FILL_THE_VALUES", "FILL THE VALUES"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("DOCUMENT_NUMBER", "DOCUMENT NUMBER");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField){
            textField.formatter = (MUIWebApplication.sharedInstance() as any).dateFormatter;
            textField.placeholderText = MIOLocalizeString("DATE", "DATE");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField){
            textField.placeholderText = MIOLocalizeString("AMOUNT", "AMOUNT");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField){
            textField.placeholderText = MIOLocalizeString("CONCEPT", "CONCEPT");
        });

        avc.addComboBoxWithConfigurationHandler(this, function (comboBox: MUIComboBox) {
            DBHelper.sharedInstance().addObserverForEntity(avc, 'Tax', null, null, null, function (objects:Tax[]) {
                comboBox.removeAllItems();
                for (let i = 0; i < objects.length; i++)
                    comboBox.addItem(objects[i].name, i);
            });
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Cancel, this, function( this:PurchaseInvoiceListViewController ){
            let reference = avc.textFields[0].text;
            let date = avc.textFields[1].text;
            let amount = avc.textFields[2].text;
            let concept = avc.textFields[3].text;
            let taxIndex = avc.comboBoxes[0].getSelectedItem();
            let tax = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, taxIndex, 'Tax') as Tax;

            this.createNextNumber(legalEntity, { "Reference": reference, 
                                                 "Date": date, 
                                                 "Amount": amount, 
                                                 "Concept": concept,
                                                 "VAT": tax
                                                } );
        } ) );
        
        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        this.presentViewController(avc, true);
    }
    
    private createInvoiceWithInfo(inv, info) 
    {
        if (info == null) return;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        if (info[ "Reference" ] != null) inv.externalReference = info[ "Reference" ];
        if (info[ "Date" ] != null) {
            let date = ad.dateFormatter.dateFromString( info[ "Date" ] + " 08:00:00" );
            inv.date = date;
        }
        
        let total = 0
        if (info[ "Amount" ] != null) {
            total = ad.currencyFormatter.numberFromString( info[ "Amount" ] );
        }
        
        let vat = info[ "VAT" ];        
        let concept = info[ "Concept" ];        

        let base = total / (1 + vat.taxQuantity);

        let line = MIOEntityDescription.insertNewObjectForEntityForName("PurchaseInvoiceLine", ad.managedObjectContext) as PurchaseInvoiceLine;
        line.document = inv;
        line.date = inv.date;
        line.quantity = 1;
        line.concept = concept;
        line.vat = vat;
        line.vatFactor = vat.taxQuantity
        line.baseAmount = base;
        line.priceAmount = base;
        line.totalAmount = total;
        line.taxesAmount = total - base;
        line.addTaxesObject(vat);

        inv.baseAmount = base;
        inv.totalAmount = total;
        inv.taxesAmount = total - base;

        inv.status = DBDocumentStatus.processed;    
    }

    private pickInvoiceFile(legalEntity:LegalEntity) {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("INVOICE_FROM_FILE", "INVOICE FROM FILE"), MIOLocalizeString("FILL_THE_VALUES", "FILL THE VALUES"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("INVOICE_NUMBER", "INVOICE NUMBER");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:PurchaseInvoiceListViewController, textField:MUITextField){
            textField.formatter = (MUIWebApplication.sharedInstance().delegate as AppDelegate).dateFormatter;
            textField.placeholderText = MIOLocalizeString("DATE", "DATE");
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("SELECT_FILE", "SELECT FILE"), MUIAlertActionStyle.Default, this, function(this:PurchaseInvoiceListViewController){
            let invoiceNumber = avc.textFields[0].text?.trim() ?? "";
            let dateString    = avc.textFields[1].text?.trim() ?? "";

            let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
            let panel = MUIOpenPanel.openPanel();
            panel.allowedFileTypes = ["pdf", "png", "jpg", "jpeg"];
            panel.beginSheetModalForWindow(ad.window, this, function(this:PurchaseInvoiceListViewController, result:number){
                if (result == MIOFileHandlingPanel.OKButton) {
                    let file = panel.files[0];
                    if (file == null) return;
                    this.importInvoiceFile(legalEntity, invoiceNumber, dateString, file);
                }
            });
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        this.presentViewController(avc, true);
    }

    private importInvoiceFile(legalEntity:LegalEntity, invoiceNumber:string, dateString:string, file:File) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        DBHelper.nextDocumentNumber("PurchaseInvoice", -1, (documentID:string, documentPrefix:string, documentNumber:number, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }

            let inv = MIOEntityDescription.insertNewObjectForEntityForName("PurchaseInvoice", ad.managedObjectContext) as PurchaseInvoice;
            inv.identifier      = MIOUUID.UUID().UUIDString;
            inv.documentNumber  = documentID;
            inv.legalEntity     = legalEntity;
            inv.externalReference = invoiceNumber;
            inv.date = dateString.length > 0
                ? ad.dateFormatter.dateFromString(dateString + " 08:00:00")
                : new Date();
            inv.accountingDate = new Date();
            inv.status = DBDocumentStatus.pending;
            // ocrStatus becomes scanning only once the file is attached: set earlier, the
            // status change can reach the extraction server before the file exists.

            DBHelper.saveMainContext();

            this.selectedItem = inv;
            this.showSelectedItem();

            ad.webService.uploadInvoiceFile(inv, file, (code:number, json:any) => {
                if (code != 200) {
                    AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_UPLOAD_FILE", "Couldn't upload file. Please try again."));
                    DBHelper.deleteObjectFromMainContext(inv, true);
                    return;
                }

                let id = json["data"]["ID"];
                if (id == null) {
                    AppHelper.showErrorMessage(null, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("FILE_ID_MISSING", "Teh file identifier is missing"));
                    DBHelper.deleteObjectFromMainContext(inv, true);
                    return;
                } 

                DBHelper.queryObjectWithCompletion( "FileAttachment", [], MIOPredicate.predicateWithFormat("identifier == " + id), [], this, function(item:FileAttachment){
                    if (item == null) {
                        AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("COULDNT_ATTACH_UPLOAD_FILE", "Couldn't attach uploaded file"));
                        return;
                    }
                    inv.addFilesObject(item);
                    inv.ocrStatus = DBDocumentOCRStatus.scanning;
                    DBHelper.saveMainContext();
                } );
            });
        });
    }

}